import { render, staticRenderFns } from "./documentation.vue?vue&type=template&id=f6bcc038"
import script from "./documentation.vue?vue&type=script&lang=js"
export * from "./documentation.vue?vue&type=script&lang=js"
import style0 from "./documentation.vue?vue&type=style&index=0&id=f6bcc038&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports